/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serviceerrortitle2Inputs */



/**
* | output |
* | --- |
* | "Oops…" |
*
* @param {Serviceerrortitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const serviceerrortitle2 = /** @type {((inputs?: Serviceerrortitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serviceerrortitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Oops…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vaya…")
	return /** @type {LocalizedString} */ ("Упс…")
});
export { serviceerrortitle2 as "serviceErrorTitle" }